import WIDGET_ITEMS_MAP from '../items/widgets';
import { useLayoutWidget, useProduct } from '@/store';
import { TItem } from '@/components/GridBoards/types';
import { createWidget } from '../layoutItems';

type ReturnOfWidgets = [TItem[], (arg: TItem[]) => void];

const useWidgets = (
  screen: number,
  siderbounds: LayoutBoxSiderbounds,
): ReturnOfWidgets => {
  const [widget, updateLayoutWidget] = useLayoutWidget();
  const [product] = useProduct();
  const WIDGET_ITEMS = WIDGET_ITEMS_MAP[product];
  const curScreenWidgets = (widget || []).filter((w) => {
    return w.screen === screen;
  });

  const result: TItem[] = curScreenWidgets.map<TItem>((w) => {
    return createWidget(w, product, siderbounds);
  });

  /**
   * 更新widget
   */
  const updateWidgets = (items: TItem[]) => {
    const tmp: PropType<ConfigLayout, 'widget'> = [];
    items.forEach((i) => {
      const _id = i.id as keyof typeof WIDGET_ITEMS;
      if (WIDGET_ITEMS[_id]) {
        tmp.push({
          className: _id,
          packageName: WIDGET_ITEMS[_id].packageName,
          screen: screen,
          x: i.x,
          y: i.y,
          spanX: i.w,
          spanY: i.h,
        });
      }
    });

    const _widget = widget!.filter((w) => w.screen !== screen);

    updateLayoutWidget([..._widget, ...tmp]);
  };

  return [result, updateWidgets];
};

export default useWidgets;
